module.exports = __webpack_public_path__ + "static/media/socialDistancing.0b9280ed.gif";